module.exports = __webpack_public_path__ + "static/img/video-pass.30e8aef2.png";